import CardFooter from './CardFooter'

export { CardFooter }
export default CardFooter
